<template>
  <section class="dashboard">
    <div class="dashboard-visual">
      <img class="dashboard-visual__img" :src="logoUrl" alt="白医云 Logo" />
    </div>
    <div class="dashboard-copy">
      <p class="dashboard-title dashboard-tag">白医云 · 智慧医疗</p>
      <p class="dashboard-line">连接检查、问诊、处方与药房，支撑中心端日常诊疗工作。</p>
      <p class="dashboard-line">请从左侧菜单选择功能模块开始工作。</p>
    </div>
  </section>
</template>

<script>
import logoUrl from '@/assets/logo/byyl-logo1.png'

export default {
  name: 'Dashboard',
  data() {
    return {
      logoUrl
    }
  }
}
</script>

<style scoped>
.dashboard {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  background: linear-gradient(120deg, #eef4ff 0%, #ffffff 42%, #f7f8fa 100%);
}

.dashboard-visual {
  flex: 1.15;
  min-width: 0;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(20px, 4vw, 56px);
  overflow: hidden;
}

.dashboard-visual__img {
  display: block;
  width: 100%;
  max-width: min(520px, 100%);
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

.dashboard-copy {
  flex: 0.85;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: clamp(20px, 3vw, 48px) clamp(28px, 4vw, 64px) clamp(20px, 3vw, 48px) clamp(12px, 2vw, 24px);
  overflow: hidden;
}

.dashboard-tag {
  margin: 0 0 10px;
  font-size: clamp(0.78rem, 1.1vw, 0.88rem);
  font-weight: 600;
  letter-spacing: 0.12em;
  color: #2563eb;
}

.dashboard-title {
  margin: 0 0 clamp(16px, 2.5vh, 28px);
  font-size: clamp(1.5rem, 2.8vw, 2.2rem);
  font-weight: 700;
  line-height: 1.25;
  color: #2563eb;
}

.dashboard-line {
  margin: 0;
  font-size: clamp(0.88rem, 1.4vw, 1rem);
  line-height: 1.75;
  color: #6b7280;
}

.dashboard-line + .dashboard-line {
  margin-top: clamp(6px, 1vh, 12px);
}

@media (max-width: 900px) {
  .dashboard {
    flex-direction: column;
  }

  .dashboard-visual {
    flex: 1.2;
    padding: 24px 32px 12px;
  }

  .dashboard-copy {
    flex: 0.8;
    align-items: center;
    text-align: center;
    padding: 12px 28px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue